import React, { useContext, useEffect, useState } from 'react';
import './WorkCompleted.scss';
import MyContext from '../Context/MyContext';
import { useNavigate } from 'react-router-dom';


const WorkCompleted = () => {
  const { work, fetchwork ,token} = useContext(MyContext);



  const Navigate=useNavigate()

 
  




 

 
  useEffect(() => {
if(token){
    fetchwork();
}else{
  Navigate('/login')
}
  }, []);

  return (
    <div className='work-completed'>
    {work && work.length > 0 ? (
      work.some((c) => c.comment ) ? (
        work
          .filter((c) => c.comment ) 
          .map((i) => {
            return (
              <div className='work-m' key={i._id}>
              <div className="status">
              <span className="completed-tag">Completed</span>
            </div>
               
                <pre className='worko'>{i.work}</pre>
                <p>{i.comment}</p>
               
              </div>
            );
          })
      ) : (
        <p>All tasks are completed</p>
      )
    ) : (
      <p>No Data Available</p>
    )}
  </div>
  
  );
};

export default WorkCompleted;
